import { createLogger } from '@/logger';
import { getAuthenticatedUser } from './cognito';
import { logout } from './logout';
import friendly from './errors';

const log = createLogger('auth.delete');

export default function deleteUser({ error, success }) {
  getAuthenticatedUser({
    error: err => friendly(err, log),
    success: ({ user }) => user.deleteUser((err) => {
      if (err) {
        error(friendly(err, log));
      } else {
        log.information({ message: 'User account deleted!' });
        logout();
        success();
      }
    }),
  });
}



// WEBPACK FOOTER //
// ./src/auth/delete.js